import { RoleEnum } from '../enums/roleEnum';

/**
 * The four permissions on BankingOpsController (Permissions.cs). They are separate because the acts are
 * not equally dangerous: reading a worklist, deciding where somebody's money goes, asserting money no
 * bank reported, and giving up on a transfer the bank may yet execute.
 *
 * `admin.superadmin` and a full Admin pass all four; AuthService.hasAdminPermission() handles that.
 * So these only bite for SubAdmins — test the gating as one.
 */
export const BankOpsPermissions = {
  View: 'bankingOps.view',
  Resolve: 'bankingOps.resolve',
  ManualFund: 'bankingOps.manualFund',
  /**
   * Giving up on a stuck sweep file (W-18). Its own permission, not folded into Resolve, because it is
   * the only action in the area that can knowingly make the same money move twice — the bank offers no
   * way to cancel, so abandoning closes our record while the bank keeps its own. Nobody holds it yet;
   * it has to be granted deliberately in the role editor.
   */
  AbandonFile: 'bankingOps.abandonFile',
} as const;

// The routes and the sidenav items all spread BANK_OPS_ACCESS, so what a SubAdmin can see and what
// they can open cannot drift apart. Write actions are gated per button on Resolve / ManualFund.
export const BANK_OPS_ACCESS = {
  roles: [RoleEnum.Admin, RoleEnum.SubAdmin],
  permission: BankOpsPermissions.View,
};
